import "/themes/merseyway/assets/sass/style.scss";

var $ = require("jquery");
require("jquery/package.json");

// import 'swiper/css';
// import 'swiper/swiper.scss';
// import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

import Swiper from 'swiper/bundle';
// import Swiper, { Navigation, Pagination } from 'swiper';
// Swiper.use([Navigation, Pagination]);

// import "swiper/modules/effect-fade";
// import "swiper/modules/navigation";
// import "swiper/modules/pagination";
// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';

// var lity = require("lity");
var tingle = require("tingle.js");
// JCF
global.module = global.module || {}
var jcf = require("jcf");

function JCF() {
	// set options for Checkbox module
	jcf.setOptions('Select', {
		"wrapNative": false,
		"flipDropToFit": false,
		"maxVisibleItems": 10
	});
	jcf.setOptions('Radio', {
		"wrapNative": true,
		"checkedClass": "checked",
		"labelActiveClass": "active"
	});

	// replace all form elements with modified default options
	// jcf.replace('button');
	jcf.replace('wpcf7-submit');
	// jcf.replace('select');
	// // jcf.replace('textarea');
	jcf.replace('input[type="checkbox"]');
	jcf.replace('input[type="file"]');
	jcf.replace('input[type="number"]');
	jcf.replace('input[type="radio"]');
	jcf.replace('input[type="file"]');
	jcf.replace('input[type="range"]');
	jcf.replace('.jcf-scrollable');
}
window.addEventListener('load', JCF);

const swiper_slider_hero = ()=>{
	let swiper_slider = document.querySelectorAll('.swiper-slider-hero');
	let prevArrow = document.querySelectorAll('.swiper-button-prev');
	let nextArrow = document.querySelectorAll('.swiper-button-next');
	swiper_slider.forEach((slider, i)=>{
		const swiper = new Swiper(slider, {
			watchOverflow: true,
			loop: true,
			// effect: 'fade',
			// autoplay: {
			// 	delay: 5000,
			// 	disableOnInteraction: false
			// },
			fadeEffect: {
				crossFade: true
			},
			// navigation: {
			// 	nextEl: prevArrow[i],
			// 	prevEl: nextArrow[i],
			// },
			pagination: {
				el: ".swiper-pagination",
				clickable: true
			},
		});
	});
};
window.addEventListener('load', swiper_slider_hero);

const swiper_slider_whatson = ()=>{
	let swiper_slider = document.querySelectorAll('.swiper-slider-whatson');
	let prevArrow = document.querySelectorAll('.swiper-slider-whatson .swiper-button-prev');
	let nextArrow = document.querySelectorAll('.swiper-slider-whatson .swiper-button-next');
	swiper_slider.forEach((slider, i)=>{
		const swiper = new Swiper(slider, {
			loop: true,
			spaceBetween: 1000,
			effect: 'fade',
			autoplay: {
				delay: 3000,
				disableOnInteraction: false
			},
			fadeEffect: {
				crossFade: true
			},
			navigation: {
				nextEl: prevArrow[i],
				prevEl: nextArrow[i],
			},


			// effect: 'fade',
			// autoplay: {
			// 	delay: 3000,
			// 	disableOnInteraction: false
			// },
			// loop: true,
			// fadeEffect: {
			// 	crossFade: true
			// },
			// spaceBetween: 1000,
			// // loop: true,
			// navigation: {
			// 	nextEl: '.swiper-button-next',
			// 	prevEl: '.swiper-button-prev'
			// }


		});
	});
};
window.addEventListener('load', swiper_slider_whatson);


function handleError(err) {
	console.log("OH NO!");
	console.log(err);
}

const endpoint = "https://api.openweathermap.org/data/2.5/weather?q=Stockport,uk&type=accurate&units=imperial&mode=JSON&APPID=a2ef9eda97ae843f7d88ce49b3390c9e";
const getWeather = fetch(endpoint);
getWeather
	.then((response) => {
		return response.json();
	})
	.then((data) => {
		// console.log(data);
		const content = document.querySelector(".weather .icon");

		const { main, name, sys, weather } = data;
		const icon = `https://s3-us-west-2.amazonaws.com/s.cdpn.io/162656/${
			weather[0]["icon"]
		}.svg`;

		console.log(icon);

		// var weather = data.weather[0].main;

		const markup = `
			<img class="city-icon" src="${icon}" alt="${
			weather[0]["description"]
			}">
		`;
		content.innerHTML = markup;

		console.log(weather);
	})
	.catch(handleError);

// Custom forms
const menu_toggles = document.querySelectorAll(".menu-toggle");
const html = document.querySelectorAll("html");
const body = document.querySelector("body");

// Open and close main navigation menus + icons
menu_toggles.forEach(menu_toggle => {
	menu_toggle.addEventListener('click', (e) => {
		e.preventDefault();
		body.classList.toggle("toggled");
		menu_toggle.classList.toggle("toggled");
		html[0].classList.toggle("lock-scroll");
	});
});
// Close main navigation menus + icons when clicking outside the menu

const dropdown_buttons = document.querySelectorAll('.menu-item-has-children .arrow');
const height = 0;
dropdown_buttons.forEach(dropdown_button => {
	dropdown_button.addEventListener('click', (e) => {
		e.preventDefault();
		if (dropdown_button.parentElement.parentElement.classList.contains('toggle')) {
			dropdown_button.parentElement.parentElement.classList.remove('toggle');
			// dropdown_button.parentElement.classList.remove('active');
		} else {
			dropdown_buttons.forEach(dropdown_button => {
				dropdown_button.parentElement.parentElement.classList.remove('toggle');
			});
			dropdown_button.parentElement.parentElement.classList.add('toggle');
		}
	});
});
